import { AccountEditEmail } from '../../components/account-edit-email/AccountEditEmail';

export const EditEmailView = () => <AccountEditEmail />;
